module.exports = __webpack_public_path__ + "img/notifikasi.02f240a4.svg";